import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function Booking() {
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [selectedTime, setSelectedTime] = useState<string>('');

  const availableDates = [
    '2025-02-01', '2025-02-03', '2025-02-05', '2025-02-08',
    '2025-02-10', '2025-02-12', '2025-02-15', '2025-02-17'
  ];

  const availableTimes = [
    '10:00', '11:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'
  ];

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    const weekday = weekdays[date.getDay()];
    return `${month}月${day}日（${weekday}）`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] to-white">
      <Navigation />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-flower-line text-3xl text-[#D4A5A5]"></i>
              </div>
            </div>
            <h1 className="text-4xl font-serif mb-6 text-[#2C2C2C]">ご予約について</h1>
            <div className="w-32 h-px bg-[#D4A5A5] mx-auto"></div>
          </div>

          {/* Information Section */}
          <div className="bg-white rounded-3xl shadow-lg p-12 mb-12">
            <div className="space-y-8 text-lg leading-relaxed text-[#4A4A4A]">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-vidicon-line text-2xl text-[#D4A5A5]"></i>
                </div>
                <p>セッションはオンライン（ビデオ通話）で行います。<br />ZoomまたはGoogle Meetをご使用ください。</p>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-mail-line text-2xl text-[#D4A5A5]"></i>
                </div>
                <p>予約確定後、お支払い用のURLをメールにてお送りします。</p>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-bank-card-line text-2xl text-[#D4A5A5]"></i>
                </div>
                <p>お支払いの確認をもって、予約確定となります。</p>
              </div>
            </div>
          </div>

          {/* Booking Calendar */}
          <div className="bg-white rounded-3xl shadow-lg p-12 mb-12">
            <h2 className="text-2xl font-serif mb-8 text-center text-[#2C2C2C]">日時を選択してください</h2>
            
            {/* Date Selection */}
            <div className="mb-10">
              <h3 className="text-lg font-medium mb-4 text-[#4A4A4A]">日付</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {availableDates.map((date) => (
                  <button
                    key={date}
                    onClick={() => setSelectedDate(date)}
                    className={`py-4 px-4 rounded-xl border-2 transition-all whitespace-nowrap cursor-pointer ${
                      selectedDate === date
                        ? 'bg-[#C9A0A0] border-[#C9A0A0] text-white'
                        : 'bg-white border-[#E8D5D5] text-[#4A4A4A] hover:border-[#C9A0A0]'
                    }`}
                  >
                    {formatDate(date)}
                  </button>
                ))}
              </div>
            </div>

            {/* Time Selection */}
            {selectedDate && (
              <div>
                <h3 className="text-lg font-medium mb-4 text-[#4A4A4A]">時間</h3>
                <div className="grid grid-cols-4 md:grid-cols-8 gap-3">
                  {availableTimes.map((time) => (
                    <button
                      key={time}
                      onClick={() => setSelectedTime(time)}
                      className={`py-3 px-2 rounded-xl border-2 transition-all whitespace-nowrap cursor-pointer ${
                        selectedTime === time
                          ? 'bg-[#C9A0A0] border-[#C9A0A0] text-white'
                          : 'bg-white border-[#E8D5D5] text-[#4A4A4A] hover:border-[#C9A0A0]'
                      }`}
                    >
                      {time}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Confirm Button */}
            {selectedDate && selectedTime && (
              <div className="mt-10 text-center">
                <button className="bg-[#B88B8B] text-white px-16 py-5 rounded-full text-lg font-medium hover:bg-[#A67A7A] transition-all shadow-md whitespace-nowrap cursor-pointer">
                  この日時で予約する
                </button>
                <p className="mt-4 text-sm text-[#888888]">
                  選択: {formatDate(selectedDate)} {selectedTime}
                </p>
              </div>
            )}
          </div>

          {/* Cancellation Policy */}
          <div className="bg-[#FFF9E6] rounded-2xl p-10">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-error-warning-line text-2xl text-[#D4A5A5]"></i>
              </div>
              <h3 className="text-2xl font-medium text-[#2C2C2C]">キャンセルについて</h3>
            </div>
            <div className="pl-12 space-y-4 text-lg leading-relaxed text-[#4A4A4A]">
              <p>前々日23:59までのご連絡で全額返金いたします。</p>
              <p>前日以降のキャンセル・無断欠席は返金できません。</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}